module.exports = {
  project_name: "ulsemo-dev",
  project_server_location: "europe-west1",
}
